<template>
    <p class="text-xs">
        {{ trans.get('wizard.newsletter.privacy_policy_01') }} 
        <a :href="'/' + lang + '/legal/' + privacyPolicyUrl" target="_blank" class="underline">{{ trans.get('wizard.newsletter.privacy_policy_02') }}</a>.
    </p>
</template>

<script>
  export default {
    props: ['privacyPolicyUrl'],
    data() {
      return {
        lang: window.appLocale,
      }
    },
  }
</script>